import React, { useCallback } from 'react';

import { ID } from 'src/shared/interfaces';

import MemberItem from '../../common/MemberItem';
import List from '../../common/List';
import { useMemberDispatch, useMemberSelector } from '../../Provider';
import {
  selectLoading,
  selectMemberList,
  selectSelectedList,
} from '../../reducers/selectors';
import { deselectMember, selectMember } from '../../reducers/actions';
import { isMemberChecked, isMemberDisabled } from '../../utils';

const MemberList: React.FC = () => {
  const dispatch = useMemberDispatch();

  const loading = useMemberSelector(selectLoading('member'));
  const list = useMemberSelector(selectMemberList);
  const selectedList = useMemberSelector(selectSelectedList);

  const handleCheck = useCallback(
    (id: ID | undefined, checked: boolean) => {
      if (id) {
        if (checked) {
          dispatch(selectMember(id));
        } else {
          dispatch(deselectMember(id));
        }
      }
    },
    [dispatch]
  );

  return (
    <List loading={loading} isEmpty={list.length === 0}>
      {list.map((item) => {
        const checked = isMemberChecked(item, selectedList);
        const disabled = isMemberDisabled(item, selectedList);
        return (
          <MemberItem
            key={item.id}
            id={item.id}
            name={item.name}
            department={item.department}
            job={item.job}
            onCheck={handleCheck}
            checked={checked}
            disabled={disabled}
          />
        );
      })}
    </List>
  );
};

export default MemberList;
